module.exports = __webpack_public_path__ + "static/img/updated_successfully_ezpay.efcd7010.svg";